import { ErrorCodeApi } from '../constants';
import { convertEnumKeysToLocale } from './convertEnumKeysToLocale';

/**
 * Generates a custom error label based on the provided error title and translation path.
 *
 * @param {Object} error - Object containing error information.
 * @param {string} error.title - The title of the error.
 * @param {string} tPath - The translation path prefix.
 * @returns {string} A string representing the custom error label. If the error title matches an error in ErrorCodeApi, the label will be a combination of the translation path and the localized error title. Otherwise, it returns 'errors.genericApiError'.
 *
 * @example
 * // Assuming ErrorCodeApi and convertEnumKeysToLocale are properly defined:
 * const error = { title: 'SOME_ERROR' };
 * const tPath = 'translation.path';
 * const errorLabel = customErrorLabel(error, tPath);
 * console.log(errorLabel); // Outputs: "translation.path.someError" or "errors.genericApiError" based on ErrorCodeApi.
 */
export function customErrorLabel(error: { title: string }, tPath: string): string {
  const logError =
    Object.values(ErrorCodeApi).findIndex(mappedError => mappedError === error.title) !== -1
      ? `${tPath}.${convertEnumKeysToLocale(error.title)}`
      : 'errors.genericApiError';
  return logError;
}
